/**
 * @description: antd 主题属性类型，包含的则支持，不包含的则不支持。更多属性参考文档地址：https://ant.design/docs/react/customize-theme-cn#seedtoken
 */
var AntdTheme = {
  /**
   * @description: 品牌色是体现产品特性和传播理念最直观的视觉元素之一。在你完成品牌主色的选取之后，我们会自动帮你生成一套完整的色板，并赋予它们有效的设计语义
   */
  colorPrimary: '#1677ff',
  /**
   * @description: 基础组件的圆角大小，例如按钮、输入框、卡片等
   */
  borderRadius: 2,
  /**
   * @description: 用于表示操作失败的 Token 序列，如失败按钮、错误状态提示（Result）组件等
   */
  colorError: '#ff4d4f',
  /**
   * @description: 用于表示操作信息的 Token 序列，如 Alert 、Tag、 Progress 等组件都有用到该组梯度变量
   */
  colorInfo: '#1677ff',
  /**
   * @description: 控制元素阴影样式
   */
  boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
  /**
   * @description: 控制占位文本的颜色
   */
  colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
  /**
   * @description: 背景色的梯度变量
   */
  colorBgBase: '#fff'
};
export default AntdTheme;